"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccasionCampaignReferenceSchema = void 0;
exports.OccasionCampaignReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/occasion-campaigns.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "OccasionCampaignReference",
    "description": "Campaign to motivate user groups to participate in mini games to get benefits like free cans or entry to an event",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:occasion-campaigns"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2NjYXNpb24tY2FtcGFpZ25zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9jb250ZW50L29jY2FzaW9uLWNhbXBhaWducy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwrQkFBK0IsR0FBRztJQUM3QyxLQUFLLEVBQUUsa0ZBQWtGO0lBQ3pGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLDJCQUEyQjtJQUNwQyxhQUFhLEVBQUUsbUhBQW1IO0lBQ2xJLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04sK0JBQStCO2FBQ2hDO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsNkVBQTZFO1NBQ3pGO0tBQ0Y7Q0FDRixDQUFBIn0=